import {
  getReasons,
  getVendorGrade,
  setClosed,
  setOpenVendor
} from './thunk';

export const builderGetReasons = (builder: any) => {
  builder.addCase(getReasons.fulfilled, (state: any, action: any) => {
    state.reasonsLoading = false;
    state.reasons = action.payload;
    state.errorReason = '';
  });
  builder.addCase(getReasons.pending, (state: any) => {
    state.reasonsLoading = true;
    state.errorReason = '';
  });
  builder.addCase(getReasons.rejected, (state: any) => {
    state.reasonsLoading = false;
    state.errorReason = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });
};

export const builderSetClose = (builder: any) => {
  builder.addCase(setClosed.fulfilled, (state: any, action: any) => {
    state.message = action.payload;
    state.errorSetClose = '';
    state.settingUpCloseVendor = false;
  });
  builder.addCase(setClosed.pending, (state: any) => {
    state.errorSetClose = '';
    state.settingUpCloseVendor = true;
  });
  builder.addCase(setClosed.rejected, (state: any) => {
    state.errorSetClose = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
    state.settingUpCloseVendor = false;
  });
};

export const builderSetOpenVendor = (builder: any) => {
  builder.addCase(setOpenVendor.pending, (state: any) => {
    state.settingUpOpenVendor = true;
    state.setOpenVendorError = '';
  });

  builder.addCase(setOpenVendor.rejected, (state: any) => {
    state.settingUpOpenVendor = false;
    state.setOpenVendorError = 'خطایی رخ داده است لطفا دوباره تلاش کنید';
  });

  builder.addCase(setOpenVendor.fulfilled, (state: any, action: any) => {
    state.settingUpOpenVendor = false;
    state.setOpenVendorError = '';
    state.setOpenVendorMessage = action.payload;
  });
};

export const builderGetVendorGrade = (builder: any) => {
  builder
    .addCase(getVendorGrade.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getVendorGrade.fulfilled, (state: any, action: any) => {
      state.vendorGrade = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getVendorGrade.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
